import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonApiService } from 'src/app/services/common-api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NzModalService } from 'ng-zorro-antd/modal';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.css'],
})
export class ManageUserComponent implements OnInit {
  tableWidth = '';
  modalWidth = '60%';
  userRole: any;
  searchFilter = '';

  tableHeading = [
    {
      title: 'NAME',
      width: '80px',
    },
    {
      title: 'EMAIL',
      width: '100px',
    },
    {
      title: 'MOBILE NO',
      width: '60px',
    },
    {
      title: 'ROLE',
      width: '80px',
    },
    {
      title: 'ACTION',
      width: '50px',
    },
  ];

  userData: any = [];
  updateModal = false;
  updateForm!: FormGroup;
  updateUserData: any;
  body = new URLSearchParams(); // DATA FOR UPDATE USER API
  delBody = new URLSearchParams(); // DATA FOR DELETE USER API

  // DB ACCESS

  dbList = [];
  bpList: any = [];
  dbData: any;
  bpData: any;
  customerDetails: any;
  reqValues: any = {};
  dbDetails: any;
  listArray = [];

  constructor(
    private apiService: CommonApiService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private modal: NzModalService
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    if (window.innerWidth > 1300) {
      this.tableWidth = '450px';
    } else {
      this.tableWidth = '300px';
    }

    if (window.innerWidth < 900) {
      this.modalWidth = '90%';
    }

    this.updateForm = this.fb.group({
      userName: [null, [Validators.required]],
      userEmail: [null, [Validators.email, Validators.required]],
      // role: [null, [Validators.required]],
      userPhoneNumber: [null, [Validators.required]],
      inActive: [true],
    });

    this.fetchData();
    this.getLegalEntity();
  }

  fetchData() {
    // this.spinner.show();
    this.apiService.commonGetMethod().subscribe((response) => {
      // console.log(response);
      this.userData = response;
      this.spinner.hide();
    });
  }

  openModal(userDetail: any) {
    this.updateModal = true;
    this.updateUserData = userDetail;
    this.listArray = userDetail.dbAccess;
    // console.log(this.updateUserData);
    this.updateForm.get('userName').setValue(userDetail.username);
    this.updateForm.get('userEmail').setValue(userDetail.email);
    this.userRole = userDetail.role;
    this.updateForm.get('userPhoneNumber').setValue(userDetail.phone);
    this.updateForm.get('inActive').setValue(userDetail.inActive);
    // API DATA
    this.body.set('sapCode', userDetail.sapCode);
    this.body.set('id', userDetail._id);
    this.delBody.set('id', userDetail._id);
  }

  closeModal() {
    this.updateModal = false;
    this.updateForm.reset();
  }

  updateUser() {
    if (this.updateForm.valid) {
      if (this.listArray.length > 0 || this.userRole == 'Admin') {
        // API HEADER DATA STARTS
        let options = {
          headers: new HttpHeaders().set(
            'Content-Type',
            'application/x-www-form-urlencoded'
          ),
        };
        // API HEADER DATA ENDS

        this.body.set('username', this.updateForm.value.userName);
        this.body.set('email', this.updateForm.value.userEmail);
        this.body.set('phone', this.updateForm.value.userPhoneNumber);
        this.body.set('role', this.userRole);
        this.body.set('inActive', this.updateForm.value.inActive);
        this.body.set(
          'dbAccess',
          JSON.stringify({ requestValue: this.listArray })
        );
        // CALL API POST METHOD FROM SERVICE
        this.apiService
          .commonPostMethod(
            this.body.toString(),
            environment.url + 'updateUserProfile',
            options
          )
          .subscribe((response: any) => {
            // console.log(response);
            if (response.status == 'success') {
              this.toastr.success(response.message, '', { timeOut: 2500 });
              this.closeModal();
              this.fetchData();
            } else {
              this.toastr.error(response.message, '', { timeOut: 2500 });
              this.closeModal();
            }
          });
      } else {
        this.selectEntityAlert('Please Add Legal Entity and Company List !');
      }
    } else {
      Object.values(this.updateForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  deleteRequest() {
    let options = {
      headers: new HttpHeaders().set(
        'Content-Type',
        'application/x-www-form-urlencoded'
      ),
      body: this.delBody,
    };
    this.modal.confirm({
      nzTitle: 'Alert !',
      nzContent: 'Sure you want to Delete the User..',
      nzOkText: 'Yes, Delete',
      nzCancelText: 'No',
      nzOnOk: () =>
        this.apiService
          .commonDeleteMethod('user-profile', options)
          .subscribe((data: any) => {
            // console.log(data);
            if (data.status == 'success') {
              this.toastr.success(data.message, '', { timeOut: 2500 });
              this.closeModal();
              this.fetchData();
            } else {
              this.toastr.error(data.message, '', { timeOut: 2500 });
              // this.closeModal();
            }
          }),
    });
  }

  // DB ACCESS SECTION

  roleChange() {
    // console.log(this.userRole);
    this.reqValues = {};
    this.bpList = [];
    this.bpData = '';
    this.dbData = '';
    this.listArray = [];
  }

  getLegalEntity() {
    let options = {
      headers: new HttpHeaders().set(
        'Authorization',
        'Bearer ' + localStorage.getItem('lkjhgfdsa')
      ),
    };
    let body = new URLSearchParams();
    this.apiService
      .commonPostMethod(
        body.toString(),
        environment.newUrl + 'api/DBList',
        options
      )
      .subscribe((data: any) => {
        // console.log(data);
        this.dbList = data.responseData;
      });
  }

  getBpList() {
    // console.log(this.dbData);
    this.bpData = '';
    this.structureDBArray(this.dbData, this.dbList, 'db');
    var role;
    if (this.userRole == 'Customer') {
      role = 'CustomerList';
    } else if (this.userRole == 'Supplier') {
      role = 'SupplierList';
    }

    let options = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + localStorage.getItem('lkjhgfdsa'))
        .set('Content-Type', 'application/json'),
    };

    let body = {
      DBCode: this.dbData,
    };

    this.apiService
      .commonPostMethod(body, environment.newUrl + 'api/' + role, options)
      .subscribe((data: any) => {
        console.log(data);
        this.bpList = data.responseData;
      });
  }

  structureDBArray(data, list, code) {
    // console.log(data);
    for (let i = 0; i < list.length; i++) {
      if (code == 'bp') {
        if (list[i].bpCode == data) {
          this.customerDetails = list[i];
        }
        this.reqValues.companyDetails = this.customerDetails;
      } else if (code == 'db') {
        if (list[i].dbCode == data) {
          this.dbDetails = list[i];
          this.reqValues.dbDetails = this.dbDetails;
        }
      }
    }
  }

  createList() {
    if (this.dbData && this.bpData) {
      let temp = [];
      if (this.listArray.length > 0) {
        for (let i = 0; i < this.listArray.length; i++) {
          temp.push(this.listArray[i].dbDetails.dbName);
        }
        if (temp.indexOf(this.reqValues.dbDetails.dbName) == -1) {
          this.listArray.push(this.reqValues);
        } else {
          this.entityAlert();
        }
      } else {
        this.listArray.push(this.reqValues);
      }
      this.reqValues = {};
      this.dbData = '';
      this.bpData = '';
      // console.log(this.listArray);
    } else {
      // Object.values(this.listForm.controls).forEach((control) => {
      //   if (control.invalid) {
      //     control.markAsDirty();
      //     control.updateValueAndValidity({ onlySelf: true });
      //   }
      // });
      this.selectEntityAlert('Please Select Legal Entity and Company List !');
    }
  }

  clearList(index, event) {
    this.clearListAlert(index);
    event.preventDefault();
    event.stopPropagation();
  }

  // ALERT MESSAGE MODALS

  clearListAlert(index) {
    this.modal.confirm({
      nzTitle: 'Sure You Want to Clear DB Access!',
      // nzContent: 'Remove Entity or Select Another Entity',
      nzOkText: 'Yes',
      nzCancelText: 'No',
      nzOnOk: () => this.listArray.splice(index, 1),
    });
  }

  entityAlert() {
    this.modal.error({
      nzTitle: 'Legal Entity already Added !',
      nzContent: 'Remove Entity or Select Another Entity',
    });
  }

  selectEntityAlert(alert) {
    this.modal.error({
      nzTitle: alert,
      // nzContent: 'Remove Entity or Select Another Entity',
    });
  }

  // TABLE PAGINATION

  onPageChange(event) {
    document.getElementById('userListTable').scrollIntoView();
  }
}
